import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function ContactsModule() {
  return <ModuleNavigation moduleId="ContactsModule" />;
}
